import React, { useState } from "react";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Button, Card, CardActions, CardContent, CardHeader, Typography} from "@mui/material";
import {setJobs} from "../redux/jobsSlice";

import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';

export const CarCard = React.memo(function CarCard({order,onRequestClose}) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const mileageOptions = useSelector(state => state.settings.mileageOptions);
    let countJobs = 0;
    let countRepairTips = 0
    order.jobs.forEach((job) => {
        if (!job.detail.detailOnly && !job.repair_tips) {
            countJobs++;
        }
        if (job.repair_tips) {
            countRepairTips++;
        }
    })
    let today = new Date();
    const selectedMileageTypeOption = mileageOptions.find(opt => opt.value === order.mileageType);
    let mileageType = '';
    if (selectedMileageTypeOption) {
        mileageType = selectedMileageTypeOption.label['ru'];
    }
    return (
        <Card sx={{margin: 1}}>
            <CardHeader title={order.year + ' ' + order.make.make + ' ' + order.serie.serie}
                // width={'fill-available'}
                        sx={{width: 'fill-available', wordBreak: 'break-word'}}
                        subheader={
                            (order.model && order.model.model_years ? order.model.model_years.replace(3000, today.getFullYear()) : '') + ' ' +
                            (order.model && order.model.model_codes ? '(' + order.model.model_codes + ')' : '') + ' ' +
                            (order.fuel && order.fuel.fuelName ? order.fuel.fuelName : '') + ' ' +
                            (order.displacement && order.displacement.displacement !== '-' ? ' ' + Number(order.displacement.displacement).toFixed(1) : '')
                        }
                        action={

                            <Button size="small"
                                    disabled={Boolean(order.success)}
                                    color={'secondary'}
                                    variant={'outlined'}
                                    sx={{
                                        "&.Mui-disabled": {
                                            color:"#035506",
                                            opacity: 1
                                        }
                                    }}
                                    onClick={() => onRequestClose(order)}
                                    title={"Закрыть заказ-наряд"}
                                    startIcon={Boolean(order.success) ? <CheckBoxOutlinedIcon/> :
                                        <CheckBoxOutlineBlankOutlinedIcon/>}
                            >
                                Выполнен
                            </Button>
                        }
            >
            </CardHeader>
            <CardContent sx={{pt: 0, pb: 0}}>
                <Typography variant="body2" color="text.secondary" component="div">
                    {order.order_date ?
                        <Typography variant="caption" component="div"
                                    display="block">Дата: {new Date(order.order_date).toLocaleDateString("ru-RU",{ timeZone: 'UTC' })}</Typography> : null}
                    {countJobs > 0 ?
                        <Typography variant="caption" component="div"
                                    display="block">Работ: {countJobs}</Typography> : null}
                    {countRepairTips > 0 ?
                        <Typography variant="caption" component="div"
                                    display="block">Рекомендаций: {countRepairTips}</Typography> : null}

                    {order.plate ?
                        <Typography component="div" variant="caption"
                                    display="block">Госномер: {order.plate}</Typography> : null}
                    {order.vin ? <Typography component="div" variant="caption"
                                             display="block">VIN: {order.vin}</Typography> : null}
                    {order.mileage ?
                        <Typography variant="caption" component="div"
                                    display="block">Пробег: {order.mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} {mileageType}</Typography> : null}

                    {/*Деталей: {order.details.reduce((sum,item) => sum + Number(item.amount), 0)}*/}
                </Typography>
            </CardContent>
            <CardActions>
                <Button size="small" onClick={() => {
                    sessionStorage.setItem('form', JSON.stringify(order))
                    dispatch(setJobs(order.jobs))
                    // dispatch(setDetails(order.details))

                    navigate('calculator')
                }}>
                    Открыть
                </Button>
                <Button size="small" onClick={() => {
                    const {workorder_id, success, mileage, ...rest} = order || {};
                    if(mileage) rest.mileage_old = mileage;
                    sessionStorage.setItem('form', JSON.stringify(rest));
                    //console.log({rest})
                    dispatch(setJobs(rest.jobs))
                    // dispatch(setDetails(order.details))

                    navigate('calculator')
                }}>
                    Копировать
                </Button>
                <Button size="small" onClick={() => {
                    const {workorder_id, jobs, mileage, ...rest} = order || {};
                    if(mileage) rest.mileage_old = mileage;
                    sessionStorage.setItem('form', JSON.stringify(rest))
                    navigate('calculator')
                }}>
                    Создать новый
                </Button>
            </CardActions>
        </Card>
    )
});